import React, { useState } from 'react'
import styled from 'styled-components'
import profile from './assets/profile_img.png';
import { useEffect, useMemo } from 'react';
import axios from 'axios';
import userEvent from '@testing-library/user-event';
import { useDispatch, useSelector } from "react-redux";
import { data } from 'jquery';
import FindPodsDetails from './FindPodsDetails'
import { NavHashLink } from 'react-router-hash-link';
import star from './assets/star.png';
import Createpod from './Createpod';
import AWS from 'aws-sdk';
import defaultimg from './assets/defaultimge.png';
import { useAuthToken } from "../TokenContext";
import { useIntl } from 'react-intl';
import { useCredentials } from '../useCredentials';
import { useTheme } from '@mui/material';
import { FaUsers, FaEnvelope, FaPhone, FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { MdPeople } from 'react-icons/md';

const FindPods = ({collapsed}) => {
  const token = useAuthToken();
  const intl = useIntl();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  
  const [Subscription, setSubscription] = useState({});
  const [subscriptionFetch, setSubscriptionFetch] = useState([]);
  const [loading, setLoading] = useState(true);
  const { credentials, isLoaded, isLoading, refresh } = useCredentials();

  const config = useMemo(() => ({
    bucketName: credentials.bucketName,
    region: credentials.region,
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey
  }), [credentials]);

  const S3Config = useMemo(() => ({
    bucketName: credentials.bucketName,
    region: credentials.region,
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey
  }), [credentials]);

  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(6); // Increased for better grid layout
  const [AuthImage, setAuthImage] = useState([]);
  const [pageNumberLimit, setPageNumberLimit] = useState(5);
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);
  const [getData, setGetData] = useState([]);
  const [GetCandidates, setGetCandidates] = useState([]);
  const [requirement, setRequirement] = useState([]);

  useEffect(() => {
    if (user && user.data && user.data.length > 0) {
      const body = {
        client_code: user.data[0].talent_code,
      };

      const headers = {
        Authorization: token,
        'Content-Type': 'application/json',
      };

      axios
        .post(process.env.REACT_APP_FETCHSUBSCRIPTIONDATA, body, { headers })
        .then((res) => {
          setSubscription(res.data.data);
          setSubscriptionFetch(res.data.data[0]?.find_pods || []);
        })
        .catch((err) => {
          console.log('catch', err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token, user]);

  const myBucket = new AWS.S3(S3Config);

  useEffect(() => {
    const fetchData = async () => {
      if (user && user.data && user.data.length > 0) {
        const headers = {
          Authorization: token,
          'Content-Type': 'application/json',
        };

        try {
          const body = {
            primary_skills: user.data[0].primaryskill,
            secondary_skills: user.data[0].secondaryskill,
            Client_Code: user.data[0].talent_code,
          };

          let findPod = await axios.post(
            process.env.REACT_APP_TALENT_FINDPODS,
            body,
            { headers }
          );

          if (findPod.data && findPod.data.data && findPod.data.data.length > 0) {
            setGetData(findPod.data.data);
            const URL_EXPIRATION_TIME = 900;

            const params = {
              Bucket: process.env.REACT_APP_BUCKETNAME,
              Key: findPod.data.data[0].picture,
              Expires: URL_EXPIRATION_TIME,
            };

            myBucket.getSignedUrl('getObject', params, (err, url) => {
              if (err) {
                console.log(err);
              } else {
                setAuthImage(url);
              }
            });
          } else {
            console.error('findPod.data.data is undefined or empty');
          }

          const getPodBody = {
            candidateID: user.data[0].c_id,
          };

          let getPod = await axios.post(
            process.env.REACT_APP_CLIENT_GETCANDIDATEPODS,
            getPodBody,
            { headers }
          );

          setGetCandidates(getPod.data.data.candidates);
        } catch (err) {
          console.log(err);
        }
      }
    };

    fetchData();
  }, [token, user]);

  const handleClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const pages = [];
  if (getData && getData.length > 0) {
    for (let i = 1; i <= Math.ceil(getData.length / itemsPerPage); i++) {
      pages.push(i);
    }
  }

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = getData.slice(indexOfFirstItem, indexOfLastItem);

  const handleNextBtn = () => {
    if (currentPage < pages.length) {
      setCurrentPage(currentPage + 1);
      if (currentPage + 1 > maxPageNumberLimit) {
        setMaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
        setMinPageNumberLimit(minPageNumberLimit + pageNumberLimit);
      }
    }
  };

  const handlePrevBtn = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      if ((currentPage - 1) % pageNumberLimit === 0) {
        setMaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
        setMinPageNumberLimit(minPageNumberLimit - pageNumberLimit);
      }
    }
  };

  if (loading) {
    return (
      <Container isDarkMode={isDarkMode}>
        <LoadingState isDarkMode={isDarkMode}>
          <LoadingSpinner isDarkMode={isDarkMode} />
          <LoadingText isDarkMode={isDarkMode}>
            {intl.formatMessage({ id: 'loading' })}...
          </LoadingText>
        </LoadingState>
      </Container>
    );
  }

  if (Subscription === "There Are No subscription data." || subscriptionFetch === "False") {
    return (
      <Container isDarkMode={isDarkMode}>
        <EmptyState isDarkMode={isDarkMode}>
          <EmptyIcon>🔒</EmptyIcon>
          <EmptyTitle isDarkMode={isDarkMode}>
            Subscription Required
          </EmptyTitle>
          <EmptyDescription isDarkMode={isDarkMode}>
            {intl.formatMessage({ id: 'noSubscription' })}
          </EmptyDescription>
        </EmptyState>
      </Container>
    );
  }

  return (
    <Container isDarkMode={isDarkMode}>
      <Header>
        <HeaderTitle isDarkMode={isDarkMode}>
          {intl.formatMessage({ id: 'findBestPod' })}
        </HeaderTitle>
        <SubTitle isDarkMode={isDarkMode}>
          Discover the perfect POD that matches your skills and requirements
        </SubTitle>
      </Header>

      {getData.length > 0 ? (
        <>
          <PodsGrid>
            {currentItems.map((pod, index) => (
              <PodCard key={index} isDarkMode={isDarkMode}>
                <PodHeader>
                  <ProfileSection>
                    <ProfileImage>
                      {pod.picture == null || pod.picture === "" ? (
                        <img
                          src={defaultimg}
                          alt="Pod leader"
                          style={{
                            width: '60px',
                            height: '60px',
                            borderRadius: '50%',
                            objectFit: 'cover'
                          }}
                        />
                      ) : (
                        <img
                          src={`https://globldataprod.s3.amazonaws.com/${pod.picture}`}
                          alt="Pod leader"
                          style={{
                            width: '60px',
                            height: '60px',
                            borderRadius: '50%',
                            objectFit: 'cover'
                          }}
                        />
                      )}
                    </ProfileImage>
                    <RatingSection>
                      <StarIcon>
                        <FaStar />
                      </StarIcon>
                      <RatingText isDarkMode={isDarkMode}>
                        {pod.rating || 'N/A'}
                      </RatingText>
                    </RatingSection>
                  </ProfileSection>
                </PodHeader>

                <PodContent>
                  <PodName isDarkMode={isDarkMode}>
                    {pod.podName}
                  </PodName>

                  <PodDetails>
                    <DetailItem>
                      <DetailIcon isDarkMode={isDarkMode}>
                        <FaEnvelope />
                      </DetailIcon>
                      <DetailLabel isDarkMode={isDarkMode}>
                        {intl.formatMessage({ id: 'email' })}:
                      </DetailLabel>
                      <DetailValue isDarkMode={isDarkMode}>
                        {pod.email}
                      </DetailValue>
                    </DetailItem>

                    <DetailItem>
                      <DetailIcon isDarkMode={isDarkMode}>
                        <FaPhone />
                      </DetailIcon>
                      <DetailLabel isDarkMode={isDarkMode}>
                        {intl.formatMessage({ id: 'phone' })}:
                      </DetailLabel>
                      <DetailValue isDarkMode={isDarkMode}>
                        {pod.phone}
                      </DetailValue>
                    </DetailItem>

                    <DetailItem>
                      <DetailIcon isDarkMode={isDarkMode}>
                        <MdPeople />
                      </DetailIcon>
                      <DetailLabel isDarkMode={isDarkMode}>
                        {intl.formatMessage({ id: 'podSize' })}:
                      </DetailLabel>
                      <DetailValue isDarkMode={isDarkMode}>
                        {pod.podSize} members
                      </DetailValue>
                    </DetailItem>
                  </PodDetails>
                </PodContent>

                <PodFooter>
                  <ActionButton isDarkMode={isDarkMode}>
                    View Details
                  </ActionButton>
                </PodFooter>
              </PodCard>
            ))}
          </PodsGrid>

          {pages.length > 1 && (
            <PaginationContainer>
              <PaginationButton
                onClick={handlePrevBtn}
                disabled={currentPage === 1}
                isDarkMode={isDarkMode}
              >
                <FaChevronLeft />
                {intl.formatMessage({ id: 'prev' })}
              </PaginationButton>

              <PageNumbers>
                {pages
                  .filter(number => number >= minPageNumberLimit + 1 && number <= maxPageNumberLimit)
                  .map((number) => (
                    <PageNumber
                      key={number}
                      onClick={() => handleClick(number)}
                      isActive={currentPage === number}
                      isDarkMode={isDarkMode}
                    >
                      {number}
                    </PageNumber>
                  ))}
              </PageNumbers>

              <PaginationButton
                onClick={handleNextBtn}
                disabled={currentPage === pages.length}
                isDarkMode={isDarkMode}
              >
                {intl.formatMessage({ id: 'next' })}
                <FaChevronRight />
              </PaginationButton>
            </PaginationContainer>
          )}
        </>
      ) : (
        <EmptyState isDarkMode={isDarkMode}>
          <EmptyIcon>🔍</EmptyIcon>
          <EmptyTitle isDarkMode={isDarkMode}>
            No PODs Found
          </EmptyTitle>
          <EmptyDescription isDarkMode={isDarkMode}>
            {intl.formatMessage({ id: 'noData' })}
          </EmptyDescription>
        </EmptyState>
      )}
    </Container>
  );
};

// Styled Components
const Container = styled.div`
  max-width: 1400px;
  margin-left: ${props => props.collapsed ? "60px" : "240px"};
  margin-right: auto;
  margin-top: 0;
  margin-bottom: 0;
  padding: 2rem;
  background-color: ${props => props.isDarkMode ? '#121212' : '#ffffff'};
  min-height: 100vh;
  transition: all 0.3s ease;
  
  /* Center within remaining space */
  width: ${props => props.collapsed ? 'calc(100vw - 60px - 4rem)' : 'calc(100vw - 240px - 4rem)'};
  transform: ${props => props.collapsed 
    ? 'translateX(calc((100vw - 60px - 1400px) / 2))' 
    : 'translateX(calc((100vw - 240px - 1400px) / 2))'
  };

  @media screen and (max-width: 768px) {
    padding: 1rem;
    width: ${props => props.collapsed ? 'calc(100vw - 60px - 2rem)' : 'calc(100vw - 240px - 2rem)'};
    transform: ${props => props.collapsed 
      ? 'translateX(calc((100vw - 60px - 1400px) / 2))' 
      : 'translateX(calc((100vw - 240px - 1400px) / 2))'
    };
  }

  @media screen and (max-width: ${props => props.collapsed ? '1520px' : '1680px'}) {
    transform: translateX(0);
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 3rem;

  @media screen and (max-width: 768px) {
    margin-bottom: 2rem;
  }
`;

const HeaderTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: ${props => props.isDarkMode ? '#ffffff' : '#2c3e50'};
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media screen and (max-width: 768px) {
    font-size: 2rem;
  }
`;

const SubTitle = styled.p`
  font-size: 1.1rem;
  color: ${props => props.isDarkMode ? '#b0b0b0' : '#6c757d'};
  margin: 0;
  max-width: 600px;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    font-size: 1rem;
  }
`;

const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
`;

const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid ${props => props.isDarkMode ? '#333' : '#f3f3f3'};
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingText = styled.p`
  color: ${props => props.isDarkMode ? '#b0b0b0' : '#6c757d'};
  font-size: 1.1rem;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 4rem 2rem;
  background-color: ${props => props.isDarkMode ? '#1e1e1e' : '#f8f9fa'};
  border-radius: 20px;
  border: 2px dashed ${props => props.isDarkMode ? '#404040' : '#dee2e6'};
  margin: 2rem 0;
`;

const EmptyIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 1.5rem;
  opacity: 0.6;
`;

const EmptyTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${props => props.isDarkMode ? '#ffffff' : '#2c3e50'};
  margin-bottom: 1rem;
`;

const EmptyDescription = styled.p`
  color: ${props => props.isDarkMode ? '#b0b0b0' : '#6c757d'};
  font-size: 1.1rem;
  line-height: 1.5;
  margin: 0;
  max-width: 500px;
  margin: 0 auto;
`;

const PodsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const PodCard = styled.div`
  background-color: ${props => props.isDarkMode ? '#1e1e1e' : '#ffffff'};
  border-radius: 20px;
  padding: 1.5rem;
  border: 1px solid ${props => props.isDarkMode ? '#333333' : '#e9ecef'};
  box-shadow: ${props => props.isDarkMode 
    ? '0 4px 20px rgba(0, 0, 0, 0.3)' 
    : '0 4px 20px rgba(0, 0, 0, 0.08)'};
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover {
    transform: translateY(-5px);
    box-shadow: ${props => props.isDarkMode 
      ? '0 8px 30px rgba(0, 0, 0, 0.4)' 
      : '0 8px 30px rgba(0, 0, 0, 0.15)'};
  }
`;

const PodHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

const ProfileSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
`;

const ProfileImage = styled.div`
  flex-shrink: 0;

  img {
    border: 3px solid ${props => props.isDarkMode ? '#404040' : '#e9ecef'};
  }
`;

const RatingSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #ffd700 0%, #ffb347 100%);
  padding: 0.5rem 1rem;
  border-radius: 25px;
  margin-left: auto;
`;

const StarIcon = styled.div`
  color: #fff;
  font-size: 1rem;
`;

const RatingText = styled.span`
  color: #fff;
  font-weight: 600;
  font-size: 0.9rem;
`;

const PodContent = styled.div`
  flex: 1;
  margin-bottom: 1.5rem;
`;

const PodName = styled.h3`
  font-size: 1.3rem;
  font-weight: 700;
  color: ${props => props.isDarkMode ? '#ffffff' : '#2c3e50'};
  margin-bottom: 1rem;
  text-align: center;
`;

const PodDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const DetailItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
  border-radius: 8px;
  background-color: ${props => props.isDarkMode ? '#2c2c2c' : '#f8f9fa'};
`;

const DetailIcon = styled.div`
  color: ${props => props.isDarkMode ? '#667eea' : '#667eea'};
  font-size: 1rem;
  width: 20px;
  display: flex;
  justify-content: center;
`;

const DetailLabel = styled.span`
  font-weight: 600;
  color: ${props => props.isDarkMode ? '#b0b0b0' : '#6c757d'};
  min-width: 60px;
  font-size: 0.9rem;
`;

const DetailValue = styled.span`
  color: ${props => props.isDarkMode ? '#ffffff' : '#2c3e50'};
  font-weight: 500;
  word-break: break-word;
  font-size: 0.9rem;
`;

const PodFooter = styled.div`
  display: flex;
  justify-content: center;
  margin-top: auto;
`;

const ActionButton = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 3rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const PaginationButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: ${props => props.isDarkMode ? '#2c2c2c' : '#ffffff'};
  color: ${props => props.isDarkMode ? '#ffffff' : '#2c3e50'};
  border: 1px solid ${props => props.isDarkMode ? '#404040' : '#dee2e6'};
  padding: 0.75rem 1.5rem;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-color: transparent;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const PageNumbers = styled.div`
  display: flex;
  gap: 0.5rem;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

const PageNumber = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid ${props => props.isDarkMode ? '#404040' : '#dee2e6'};
  background-color: ${props => props.isActive 
    ? '#667eea' 
    : props.isDarkMode ? '#2c2c2c' : '#ffffff'};
  color: ${props => props.isActive 
    ? '#ffffff' 
    : props.isDarkMode ? '#ffffff' : '#2c3e50'};
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-color: transparent;
  }
`;

export default FindPods;